import ArchiveContent from "./ArchiveContent";

export default function ArchiveDesktop() {
    return(
        <div className="pb-24">
            <ArchiveContent/>
        </div>
    )
}